import React from 'react';
import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import ScrollableTable from 'components/ScrollableTable';

type CallsMadeDialogProps = {
  id: number;
  taskDate: string;
  companyMaster: { label: string; value: string };
  companyBranch: { label: string; value: string };
  contactedWith: { label: string; value: string }[];
  title: string;
  description: string;
  followUpMode: string;
};

export default function CallsMadeDialog({ salesCallsMade }: { salesCallsMade: CallsMadeDialogProps[] }) {
  return (
    <ScrollableTable
      columns={[
        { label: 'Date', key: 'taskDate', align: 'left', width: '100px' },
        { label: 'Company', key: 'companyMaster', align: 'left', width: '150px' },
        { label: 'Branch', key: 'companyBranch', align: 'left', width: '150px' },
        { label: 'Contacted With', key: 'contactedWith', align: 'left', width: '150px' },
        { label: 'Title', key: 'title', align: 'left', width: '200px' },
        { label: 'Description', key: 'description', align: 'left', minWidth: '400px', width: '500px' },
        { label: 'Mode', key: 'followUpMode', align: 'left', width: '100px' },
      ]}
      data={salesCallsMade}
      renderCell={(column, row) => {
        if (column.key === 'taskDate') {
          return <Typography variant="body2">{dayjs(row.taskDate).format('DD/MM/YY')}</Typography>;
        }
        if (column.key === 'companyMaster') {
          return <Typography variant="body2">{row.companyMaster?.label ?? '-'}</Typography>;
        }
        if (column.key === 'companyBranch') {
          return <Typography variant="body2">{row.companyBranch?.label ?? '-'}</Typography>;
        }
        if (column.key === 'contactedWith') {
          return (
            <Typography variant="body2">{row.contactedWith?.map((c: any) => c.label).join(', ') || '-'}</Typography>
          );
        }
        if (column.key === 'title') {
          return <Typography variant="body2">{row.title || '-'}</Typography>;
        }
        if (column.key === 'description') {
          return (
            <Typography
              variant="body2"
              sx={{
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                whiteSpace: 'normal',
              }}
              dangerouslySetInnerHTML={{ __html: row.description || '-' }}
            />
          );
        }
        if (column.key === 'followUpMode') {
          return <Typography variant="body2">{row.followUpMode ?? '-'}</Typography>;
        }
        return null;
      }}
      emptyMessage="No calls found"
      maxHeight="100%"
    />
  );
}
